import React from 'react';
import '../../pages/dashboardtablepage/DashboardTablePage.css'
import InteractiveMap from "../../../pages/InteractiveMap/InteractiveMap";

const DashboardMap = () => {
    return (
        <div >
                <InteractiveMap />
        </div>
    );
};

export default DashboardMap;
